import React from 'react';
import { PaymentRequestsTable } from '@widgets/PaymentRequestsTable';

export const PaymentRequestsPage: React.FC = () => {
    return <PaymentRequestsTable />;
};
